// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root___T2MI","inputWrap":"Table_inputWrap__2rJms","col":"Table_col__1625a","bmiTooltip":"Table_bmiTooltip__1UXnu"};